import { CountryCode } from 'libphonenumber-js/mobile';

export type ProjectMobileCountry = {
  countryCode: CountryCode;
  name: string;
  prefix: string;
};

const AUSTRALIA: ProjectMobileCountry = { countryCode: 'AU', name: 'Australia', prefix: '+61' };
const NEW_ZEALAND: ProjectMobileCountry = { countryCode: 'NZ', name: 'New Zealand', prefix: '+64' };

// Projects only ever have Australia or New Zealand set. Anything else (including no country) falls back to Australia.
export const getProjectMobileCountry = (projectCountry?: string | null): ProjectMobileCountry =>
  projectCountry === NEW_ZEALAND.name ? NEW_ZEALAND : AUSTRALIA;

// Converts what the user typed into an international number. Typing a full international number (leading '+')
// is left as-is so a mismatching number can be corrected; anything else is treated as a local number.
export const toInternationalMobile = (typed: string, country: ProjectMobileCountry): string => {
  const digits = typed.replace(/\D/g, '');
  if (typed.trim().startsWith('+')) {
    return digits ? `+${digits}` : '';
  }
  const local = digits.replace(/^0+/, '');
  return local ? `${country.prefix}${local}` : '';
};

export const hasMobilePrefix = (mobile: string | undefined | null, country: ProjectMobileCountry): boolean =>
  !mobile || mobile.startsWith(country.prefix);

export const toLocalMobile = (mobile: string, country: ProjectMobileCountry): string =>
  mobile.startsWith(country.prefix) ? mobile.slice(country.prefix.length) : mobile;
